// 连接地址
// const apiHttpUrl = "http://localhost:8080";  // 本地
const apiHttpUrl = "https://stg-career.gehealthcare.cn/career_m";  // stg 基础路径,将统一的部分全部封装
// const apiHttpUrl = "https://career.gehealthcare.cn/career_m";   // pord 生产 基础路径,将统一的部分全部封装

export default {
  apiHttpUrl
};



// WEBPACK FOOTER //
// ./src/utils/global.js